function showReviews () { 
  $( "#agWidgetStars" ).on( "click", function() { 
      console.log("haha");
      const element = document.getElementById("ag-s");
      element.scrollIntoView();
      $( "a.tab-title").each(function(e) { 
        console.log("hhaha", $(this).attr("href"));
        if($(this).attr("href") == "#tab-avis" ) { 
          $( "a.tab-title") .removeClass('is-open'); 
          $('.tabs-contents .tab-content').removeClass('is-active');
          $('.tabs-contents .tab-content .toggle-content').removeClass('is-active');
          $(this).addClass('is-open'); 
          $('#tab-avis').addClass('is-active');
          $('#tab-avis .toggle-content').addClass('is-active');
        } 
      }); 
  }); 
}